// src/utils/act/actBreakdownData.js
//
// Firestore I/O for the ACT breakdown: loads the question index from
// act_diagnostic_tests/{testId}/questions and the student's answers +
// scienceSkipped flag from the diagnostic_results doc.

import { db } from "../../firebaseConfig";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";

export async function loadActBreakdownInputs({ testId, attemptId, studentId, answers: answersProp }) {
  const qSnap = await getDocs(collection(db, "act_diagnostic_tests", testId, "questions"));
  const questionIndex = new Map();
  qSnap.forEach((d) => {
    const v = d.data() || {};
    const key = v.questionId || d.id;
    questionIndex.set(key, {
      subject: v.subject,
      category: v.category || v.subcategory || v.skill || "Uncategorized",
      correctAnswer: v.correctAnswer,
    });
  });

  let answers = answersProp;
  let scienceSkipped = false;
  const ref = doc(db, "diagnostic_results", attemptId || studentId);
  const snap = await getDoc(ref);
  if (snap.exists()) {
    const data = snap.data() || {};
    if (!answers) answers = data.answers || {};
    scienceSkipped = !!data.scienceSkipped;
  }

  return { questionIndex, answers: answers || {}, scienceSkipped };
}
